module.exports = __webpack_public_path__ + "/content/shared/img/honda/logo-driven-by-rms.png";